import { Emoji, MessagesResponse as Response, User } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { useChatWebsocketContext } from 'chat/websocket/context'
import { useUser } from 'users/queries/detail'
import { updateReactionData } from './shared/utils'

type ReactionVariables = {
  conversationId: string
  messageId: string
  emoji: Emoji
}

export function useCreateReaction() {
  const client = useQueryClient()
  const { server } = useServer()
  const { data: user } = useUser()
  const { sendWebsocketMessage } = useChatWebsocketContext()
  return useMutation({
    mutationFn: createReaction,
    onSuccess: async event => {
      await updateReactionData(client, event, user as User | undefined)
      sendWebsocketMessage({
        action: 'sendMessageEvent',
        messageEvent: event,
      })
    },
  })

  function createReaction({
    conversationId,
    messageId,
    emoji,
  }: ReactionVariables) {
    return server.post<Response.AddReactionEvent>(
      `/v2/chat/conversations/${conversationId}/messages/${messageId}/react`,
      getReactionForm(),
      'user',
      'multipart/form-data'
    )

    function getReactionForm() {
      const form = new FormData()
      form.append('reactionName', String(emoji))
      return form
    }
  }
}
